import {Component} from '@angular/core';

import {GlobalState} from '../../../global.state';
import { EventsService } from "app/services/events";

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {
  evento: any;

  public isScrolled:boolean = false;
  public isMenuCollapsed:boolean = false;
  public avatar:any = '';
  public Array = Array;

  constructor(private _state:GlobalState, private events:EventsService) {
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });

    this.avatar = ((localStorage.getItem('avatar') !== 'null') ? localStorage.getItem('avatar') : ('nullAvatar.png').split('.'));
    this.evento = events.getEvento();
  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }

  public perfil(){
    
  }

  public logout(){
    this.evento.emit({tipo:'user:logout'});
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baPageTop/baPageTop.component.ts